export const HARDCOST_TYPE_AMOUNT = 'Amount'
export const HARDCOST_TYPE_PERCENT = 'Percent'
export const HARDCOST_TYPE_CPM = 'CPM'

export const HardCostTypes = [
  { value: HARDCOST_TYPE_AMOUNT, label: 'Amount' },
  { value: HARDCOST_TYPE_PERCENT, label: 'Percentage' },
  { value: HARDCOST_TYPE_CPM, label: 'CPM' },
]
